<template>
  <v-app>
    <v-app-bar 
    v-if="$route.path != '/login'"
      app
      color="tertiary"
      dark
    >
    <div class="d-flex" width="100%" style="width:100%!important">

        <v-img
        alt="Jeingenekoa Logo"
        class="shrink mr-2"
        contain
        :width="$vuetify.breakpoint.smAndDown?'10%':'5%'"
        src="@/assets/logo_pestana.png" 
        transition="scale-transition"
        @click="$route.path == '/'?'':$router.push({path:'/'})"
        style="cursor:pointer; "
        />
        <v-img
          alt="Jeingenekoa Name"
          class="shrink mt-1"
          contain
          min-width="100"
          src="@/assets/logo_jeingenekoa_letras.png" 
          width="20%"
          @click="$route.path == '/'?'':$router.push({path:'/'})"
          style="cursor:pointer;"

        />
        
        <!-- <span>aaaaa</span> -->
        <v-spacer></v-spacer>
        <v-menu style="background-color:red;" v-if="$vuetify.breakpoint.smAndDown">
          <template v-slot:activator="{ on }">
            <v-icon color="secondary" v-on="on">mdi-dots-vertical</v-icon>
          </template>
          <v-list class="pt-0 pb-0">
            <v-list-item class="justify-center" v-for=" (route, index) in $router.getRoutes().slice(0,4)" :style="myTab == index?'background-color: rgb(220, 237, 200); color:rgba(109, 76, 65, 1)':'background-color: rgb(241, 248, 233); color:rgba(109, 76, 65, 1)'"  :key="index" @click="goTo(route, index)">{{ route.name }}</v-list-item>
            <v-list-item class="justify-center" style="color: rgb(241, 248, 233); background-color:rgba(109, 76, 65, 1)" @click="logout">Saioa Itxi</v-list-item>
          </v-list>
        </v-menu>
        
      </div>

    <!-- Pestañas para pantallas pequeñas -->


      <!-- Pestañas para pantallas más grandes -->
      <v-tabs color="secondary" v-model="myTab" v-if="!$vuetify.breakpoint.smAndDown"  class="scrollable-tabs">
        <v-spacer></v-spacer>
        <v-tab v-for=" (route, index) in $router.getRoutes().slice(0,4)" style="color:rgba(109, 76, 65, 1)" :key="index" @click="goTo(route, index)">{{route.name}}</v-tab>
      </v-tabs>

      <!-- Cerrar sesión -->
      <v-tooltip v-if="!$vuetify.breakpoint.smAndDown"  bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="mt-1 mb-1 mr-xs-1 " v-on="on" @click="logout" text>
            <v-icon color="secondary">mdi-logout</v-icon>
          </v-btn>
        </template>
        <span >Saioa Itxi</span>
      </v-tooltip>
    </v-app-bar>

    <v-main>
      <v-card-title v-if="$vuetify.breakpoint.smAndDown && $route.path != '/login' && $route.name != 'Fitxajeak'" style="color:rgba(109, 76, 65, 1)">{{ $route.name }}</v-card-title>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'App',

  data: () => ({

    //
  }),
  computed:{
    myTab:{
      get(){
        return this.$router.getRoutes().findIndex(e => e.name == this.$route.name)
      },
      set(){
      }
    }
  },
  created(){
    // if(localStorage.getItem("user")){
      this.cargaInicial();
    // }
  },
  
  methods:{
    ...mapActions('api',['logout']),
    ...mapActions(['cargaInicial']),
    goTo(route, index){
      this.$route.name != route.name ? this.$router.push({name: route.name}):null
      this.myTab = index
    }
  }
};
</script>
